import { render, staticRenderFns } from "./time.vue?vue&type=template&id=3d2e58cb&scoped=true"
import script from "./time.vue?vue&type=script&lang=js"
export * from "./time.vue?vue&type=script&lang=js"
import style0 from "./time.vue?vue&type=style&index=0&id=3d2e58cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e58cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2e58cb')) {
      api.createRecord('3d2e58cb', component.options)
    } else {
      api.reload('3d2e58cb', component.options)
    }
    module.hot.accept("./time.vue?vue&type=template&id=3d2e58cb&scoped=true", function () {
      api.rerender('3d2e58cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/TimeLimitForSigning/time.vue"
export default component.exports